import { grts, responseReducers } from "./reducerHelpers/dispatchProps";

const rts = {
  handleInit_pageArea: 'handleInit_pageArea',
  // handleUpdatePageItemsShown: 'handleUpdatePageItemsShown',
  handleAmmend_pageItemElemCache: 'handleAmmend_pageItemElemCache',
  handleAmmend_pageData: 'handleAmmend_pageData',
  handleOverlay: 'handleOverlay',
  ...grts
}

export const pageAreaInitialState = (initState) => {
  return { ...initState, piElemsCache: new Map() }
};

export const pageAreaReducer = (state, action) => {

  const { type } = action

  switch (type) {
    case rts.handleInit_pageArea:
      return { ...state, ...action.initProps }

    case rts.handleOverlay:
      return { ...state, lpm: action.lpm }

    case rts.handleAmmend_pageData:
      return { ...state, pageData: action.pageData }

    // case rts.handleUpdatePageItemsShown:
    //   return state

    case rts.handleAmmend_pageItemElemCache:
      const { cacheKey, elements } = action;
      const updatedCache = new Map(state.piElemsCache);
      updatedCache.set(cacheKey, elements);
      return { ...state, piElemsCache: updatedCache }

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { questionProps: null })

    default:
      return { ...state }
  }
}

export const pageAreaHandlers = (dispatch) => {
  return {
    handleOverlay: (lpm) => { dispatch({ type: rts.handleOverlay, dispatch, lpm }) },
    handleInit_pageArea: (initProps) => { dispatch({ type: rts.handleInit_pageArea, dispatch, initProps }) },
    handleAmmend_pageData: (pageData) => { dispatch({ type: rts.handleAmmend_pageData, dispatch, pageData }) },
    handleAmmend_pageItemElemCache: (cacheKey, elements) => { dispatch({ type: rts.handleAmmend_pageItemElemCache, dispatch, cacheKey, elements }) },
    // handleUpdatePageItemsShown: (googleSheetsPreview) => { dispatch({ type: rts.handleUpdatePageItemsShown, dispatch, googleSheetsPreview }) },
  }
}
